var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "customer-table__entry",
      class: { active: _vm.selected, checked: _vm.isChecked }
    },
    [
      _c(
        "div",
        {
          staticClass: "customer-table__item customer-table__image",
          on: {
            click: function($event) {
              _vm.handleSelect(_vm.customer)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "customer-table__avatar" },
            [_c("placeholder-avatar", { attrs: { initials: _vm.initials } })],
            1
          ),
          _c(
            "div",
            { staticClass: "customer-table__check" },
            [
              _c("q-checkbox", {
                model: {
                  value: _vm.checked,
                  callback: function($$v) {
                    _vm.checked = $$v
                  },
                  expression: "checked"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "customer-table__item customer-table__name",
          class: { small: _vm.small },
          on: {
            click: function($event) {
              _vm.handleSelect(_vm.customer)
            }
          }
        },
        [
          _c("span", { staticClass: "q-body-2" }, [
            _vm._v(_vm._s(_vm.customer.name))
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.small,
              expression: "!small"
            }
          ],
          staticClass: "customer-table__item customer-table__email gt-lg"
        },
        [
          _c("a", { attrs: { href: "mailto:" + _vm.email } }, [
            _vm._v(_vm._s(_vm.email))
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.small,
              expression: "!small"
            }
          ],
          staticClass: "customer-table__item customer-table__phone gt-lg"
        },
        [_vm._v("\n    " + _vm._s(_vm.phone) + "\n  ")]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.small,
              expression: "!small"
            }
          ],
          staticClass: "customer-table__item customer-table__tools"
        },
        [
          _c(
            "q-btn",
            {
              attrs: {
                icon: "more_vert",
                color: "grey-7",
                flat: "",
                round: "",
                dense: ""
              }
            },
            [_c("customer-popover", { attrs: { customers: [_vm.customer] } })],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selected,
              expression: "selected"
            }
          ],
          staticClass: "customer-table__item customer-table__deselect",
          on: { click: _vm.handleDeselect }
        },
        [_c("q-icon", { attrs: { name: "close" } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }